import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditosaptashrungicab() {



    const cardData = {





keyword: "Shirdi to Saptashrungi Cab",

headingDescription: "Sai Shirdi Cab provides comfortable and reliable Shirdi to Saptashrungi Cab service for devotees, families, senior citizens, tourists, and groups traveling from Shirdi to Saptashrungi Gad in Maharashtra. Customers can book private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way journeys, round trips, same-day pilgrimage visits, and customized religious tours. With experienced drivers, clean and well-maintained vehicles, comfortable seating, sufficient luggage space, flexible pickup timings, and convenient drop arrangements, travelers can enjoy a smooth journey without changing vehicles. The cab service also allows devotees to combine Saptashrungi with nearby temples, scenic locations, and important destinations around Nashik according to their preferred pilgrimage itinerary.",

topPlaces: [
  {
    title: "Saptashrungi Gad",
    description: "Saptashrungi Gad is the main destination on this pilgrimage route and is home to the revered Saptashrungi Devi Temple. The temple is situated in the Sahyadri ranges and holds great importance among devotees visiting Maharashtra's religious sites. Travelers from Shirdi can book a private cab for convenient transportation and plan their darshan according to their preferred schedule."
  },
  {
    title: "Saptashrungi Devi Temple",
    description: "Saptashrungi Devi Temple is the primary spiritual attraction at Saptashrungi Gad and attracts devotees throughout the year. Families, senior citizens, and groups can travel comfortably from Shirdi with a private chauffeur-driven cab. Sai Shirdi Cab provides flexible pickup and return arrangements to make the pilgrimage more convenient."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious and cultural city near Saptashrungi and can be included in an extended pilgrimage itinerary. Travelers can visit temples, heritage attractions, and other important locations around the city. Customers can customize their private cab journey to include Nashik before or after their Saptashrungi temple visit."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a renowned pilgrimage destination near Nashik and is home to one of the twelve Jyotirlinga temples dedicated to Lord Shiva. Devotees traveling from Shirdi to Saptashrungi can combine Trimbakeshwar with their religious journey. A private cab offers convenient transportation between these important Maharashtra pilgrimage destinations."
  },
  {
    title: "Vani",
    description: "Vani is the nearest major town associated with the Saptashrungi pilgrimage and serves as an important access point for visitors traveling toward the hill shrine. Customers can arrange direct cab transportation through Vani while planning their temple visit. Private vehicles provide comfortable travel for families and senior citizens with flexible pickup and drop options."
  },
  {
    title: "Dindori",
    description: "Dindori is a town in the Nashik region that can be included as an additional stop while exploring destinations around Saptashrungi. Its location makes it suitable for travelers planning a broader religious or local sightseeing itinerary. Sai Shirdi Cab provides customized cab arrangements for passengers who want to cover multiple destinations in one journey."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a scenic destination in the Nashik region known for mountains, valleys, waterfalls, and peaceful natural surroundings. Travelers extending their Saptashrungi pilgrimage can include Igatpuri for sightseeing and relaxation. Customers can choose a spacious private vehicle for comfortable travel with family, friends, and luggage."
  }
],




"services": [
  {
    "name": "Shirdi to Saptashrungi Taxi Fare",
    "description": "Shirdi to Saptashrungi Taxi Fare depends on the selected vehicle, journey type, passenger requirements, and travel schedule. Sedan, Ertiga, Innova, Innova Crysta, SUV, and larger group vehicles can be arranged for a comfortable pilgrimage journey."
  },
  {
    "name": "Shirdi to Saptashrungi Cab Package",
    "description": "Shirdi to Saptashrungi Cab Package provides private transportation for devotees traveling from Shirdi to Saptashrungi Vani. The journey can be customized for temple darshan, one-day trips, family travel, group tours, and return transportation."
  },
  {
    "name": "Shirdi to Saptashrungi Vani Cab Booking",
    "description": "Shirdi to Saptashrungi Vani Cab Booking allows devotees to arrange their private vehicle in advance for a convenient temple journey. Suitable cars can be selected according to passenger count, luggage, travel date, and one-way or round-trip requirements."
  },
  {
    "name": "Shirdi to Vani Gad Cab Booking",
    "description": "Shirdi to Vani Gad Cab Booking provides comfortable private transportation for travelers visiting the Saptashrungi region. The service is suitable for families, senior citizens, devotees, and groups planning a direct pilgrimage or customized temple tour."
  },
  {
    "name": "Shirdi to Vani Cab Booking",
    "description": "Shirdi to Vani Cab Booking offers convenient transportation for passengers traveling to Vani from Shirdi. Private AC vehicles can be arranged for temple darshan, family journeys, group travel, sightseeing, and planned return trips."
  },
  {
    "name": "Shirdi to Vani Saptashrungi Taxi Service",
    "description": "Shirdi to Vani Saptashrungi Taxi Service provides private transportation for devotees visiting Saptashrungi Mata Temple. Different vehicle categories can be arranged according to group size, luggage requirements, comfort preferences, and journey duration."
  },
  {
    "name": "Shirdi to Saptashrungi Darshan Cab Booking",
    "description": "Shirdi to Saptashrungi Darshan Cab Booking makes it convenient to arrange transportation for a temple visit from Shirdi. The service can be planned for individual devotees, families, senior citizens, and groups with suitable vehicle options."
  },
  {
    "name": "Shirdi to Saptashrungi Tour Package",
    "description": "Shirdi to Saptashrungi Tour Package provides private cab transportation for travelers combining Shirdi and Saptashrungi temple visits. The itinerary can be customized with darshan stops, Nashik sightseeing, overnight stays, and return travel."
  },
  {
    "name": "Shirdi to Saptashrungi Mini Bus Booking",
    "description": "Shirdi to Saptashrungi Mini Bus Booking is suitable for large families, pilgrimage groups, and organized travelers. Spacious group transportation can be arranged for temple darshan, group tours, multiple stops, and planned return journeys."
  },
  {
    "name": "Shirdi to Vani Saptashrungi Tempo Traveller on Rent",
    "description": "Shirdi to Vani Saptashrungi Tempo Traveller on Rent provides spacious transportation for devotees traveling in larger groups. Traveller vehicles can be arranged for one-day pilgrimage trips, multi-day tours, family journeys, and customized temple itineraries."
  },
  {
    "name": "Shirdi to Nashik Darshan Cab Service",
    "description": "Shirdi to Nashik Darshan Cab Service provides convenient private transportation for travelers planning Nashik sightseeing and temple visits. The journey can be combined with Saptashrungi darshan and other nearby religious destinations."
  },
  {
    "name": "Shirdi to Saptashrungi Cab",
    "description": "Shirdi to Saptashrungi Cab offers comfortable private transportation between Shirdi and Saptashrungi Vani. The service is suitable for devotees, families, couples, senior citizens, and groups planning temple darshan or sightseeing."
  },
  {
    "name": "Shirdi to Saptashrungi Taxi",
    "description": "Shirdi to Saptashrungi Taxi provides a convenient travel option for passengers visiting Saptashrungi Mata Temple. Sedan, Ertiga, Innova, SUV, and larger vehicles can be selected according to passenger and luggage requirements."
  },
  {
    "name": "Shirdi to Saptashrungi Cab Service",
    "description": "Shirdi to Saptashrungi Cab Service provides private outstation transportation for devotees traveling from Shirdi to Vani. The service can be used for one-way transfers, return journeys, temple tours, family trips, and group pilgrimages."
  },
  {
    "name": "Shirdi to Saptashrungi Taxi Service",
    "description": "Shirdi to Saptashrungi Taxi Service offers comfortable transportation for travelers planning a pilgrimage to Saptashrungi. Private AC vehicles can be arranged according to the preferred travel date, passenger count, and journey type."
  },
  {
    "name": "Shirdi to Saptashrungi Cab Booking",
    "description": "Shirdi to Saptashrungi Cab Booking allows travelers to arrange their vehicle before starting the journey. Customers can select an appropriate cab for solo travel, family trips, senior citizens, groups, and customized temple tours."
  },
  {
    "name": "Cab from Shirdi to Saptashrungi",
    "description": "Cab from Shirdi to Saptashrungi provides point-to-point transportation for devotees visiting the Saptashrungi Mata Temple. Comfortable vehicles can be arranged for direct journeys, sightseeing plans, and round-trip pilgrimage travel."
  },
  {
    "name": "Taxi from Shirdi to Saptashrungi",
    "description": "Taxi from Shirdi to Saptashrungi offers private transportation for travelers heading to Vani. The service is suitable for families, devotees, senior citizens, couples, and groups requiring a convenient vehicle for temple travel."
  },
  {
    "name": "Shirdi to Saptashrungi Devi Cab",
    "description": "Shirdi to Saptashrungi Devi Cab provides private transportation for devotees visiting Saptashrungi Devi Temple at Vani. Cars and larger vehicles can be arranged for comfortable darshan trips and customized pilgrimage routes."
  },
  {
    "name": "Shirdi to Saptashrungi Mata Taxi",
    "description": "Shirdi to Saptashrungi Mata Taxi offers convenient transportation for devotees traveling from Shirdi to Saptashrungi Mata Temple. Suitable vehicle categories can be selected for individual, family, and group pilgrimage requirements."
  },
  {
    "name": "Shirdi Saptashrungi Darshan Cab",
    "description": "Shirdi Saptashrungi Darshan Cab provides private transportation for devotees planning temple darshan from Shirdi. The journey can be organized as a one-day trip or combined with Nashik and nearby religious attractions."
  },
  {
    "name": "Shirdi to Saptashringi Cab",
    "description": "Shirdi to Saptashringi Cab provides a convenient private travel option for devotees visiting the Saptashrungi temple. Sedan, SUV, Ertiga, Innova, and group vehicles can be arranged according to passenger requirements."
  },
  {
    "name": "Shirdi to Saptshrungi Taxi",
    "description": "Shirdi to Saptshrungi Taxi offers comfortable transportation for travelers visiting Saptashrungi Vani. Private cabs can be arranged for temple darshan, family travel, group journeys, and return transportation."
  },
  {
    "name": "Sedan Cab Shirdi to Saptashrungi",
    "description": "Sedan Cab Shirdi to Saptashrungi is suitable for couples, individual travelers, and small families seeking comfortable private transportation. Air-conditioned sedan cars can be arranged for direct temple journeys and return trips."
  },
  {
    "name": "Swift Dzire Cab Shirdi to Saptashrungi",
    "description": "Swift Dzire Cab Shirdi to Saptashrungi provides a practical transportation option for small families and individual devotees. The sedan can be arranged for temple darshan, one-way travel, sightseeing, and round-trip journeys."
  },
  {
    "name": "Ertiga Cab Shirdi to Saptashrungi",
    "description": "Ertiga Cab Shirdi to Saptashrungi offers spacious transportation for families and small groups. The vehicle provides comfortable seating and luggage space for devotees traveling to Saptashrungi for darshan and nearby sightseeing."
  },
  {
    "name": "Innova Cab Shirdi to Saptashrungi",
    "description": "Innova Cab Shirdi to Saptashrungi is a suitable option for families and groups looking for additional space during their pilgrimage journey. It can be arranged for temple visits, sightseeing, one-way travel, and return trips."
  },
  {
    "name": "Innova Crysta Shirdi to Saptashrungi",
    "description": "Innova Crysta Shirdi to Saptashrungi provides a spacious and premium travel option for families, groups, and devotees carrying additional luggage. The vehicle is suitable for comfortable temple journeys and multi-stop pilgrimage tours."
  },
  {
    "name": "Kia Carens Cab Shirdi to Saptashrungi",
    "description": "Kia Carens Cab Shirdi to Saptashrungi provides comfortable multi-passenger transportation for families and small groups. The vehicle can be arranged for temple darshan, sightseeing, one-day trips, and customized pilgrimage travel."
  },
  {
    "name": "Seven-Seater Cab Shirdi to Saptashrungi",
    "description": "Seven-Seater Cab Shirdi to Saptashrungi is suitable for families and groups requiring additional passenger capacity. Spacious vehicles can be arranged for devotees traveling together for temple darshan and nearby religious destinations."
  },
  {
    "name": "Tempo Traveller Shirdi to Saptashrungi",
    "description": "Tempo Traveller Shirdi to Saptashrungi offers spacious group transportation for larger families, friends, and pilgrimage groups. Traveller vehicles can be arranged for one-day tours, multi-day journeys, temple visits, and customized routes."
  },
  {
    "name": "Mini Bus Shirdi to Saptashrungi",
    "description": "Mini Bus Shirdi to Saptashrungi provides group transportation for larger pilgrimage parties and organized temple tours. It is suitable for devotees traveling together for darshan, sightseeing, and multi-destination religious journeys."
  },
  {
    "name": "Family Cab Shirdi to Saptashrungi",
    "description": "Family Cab Shirdi to Saptashrungi provides comfortable private transportation for families visiting Saptashrungi Mata Temple. Vehicle options can be selected according to family size, luggage, senior citizen requirements, and preferred travel schedule."
  },
  {
    "name": "Group Taxi Shirdi to Vani",
    "description": "Group Taxi Shirdi to Vani is suitable for friends, families, and pilgrimage groups traveling together. Spacious vehicles can be arranged for Saptashrungi darshan, Nashik visits, sightseeing, and return transportation."
  },
  {
    "name": "Urbania on Rent Shirdi to Saptashrungi",
    "description": "Urbania on Rent Shirdi to Saptashrungi provides a spacious premium group travel option for larger families and organized pilgrimage groups. The vehicle can be used for temple tours, multi-day journeys, sightseeing, and customized itineraries."
  },
  {
    "name": "Shirdi to Saptashrungi Darshan Package",
    "description": "Shirdi to Saptashrungi Darshan Package provides private transportation for devotees planning a convenient temple visit from Shirdi. The package can be customized for one-day travel, return trips, family journeys, and combined Nashik sightseeing."
  },
  {
    "name": "Shirdi Saptashrungi Mata Darshan Cab",
    "description": "Shirdi Saptashrungi Mata Darshan Cab offers private transportation for devotees visiting Saptashrungi Mata Temple. Comfortable vehicle options can be arranged for families, senior citizens, couples, and groups."
  },
  {
    "name": "Saptashrungi Devi Darshan Taxi from Shirdi",
    "description": "Saptashrungi Devi Darshan Taxi from Shirdi provides a convenient private journey to Vani for temple darshan. The service can be planned as a dedicated pilgrimage trip or combined with Nashik and nearby religious destinations."
  },
  {
    "name": "Shirdi to Vani Devi Darshan Package",
    "description": "Shirdi to Vani Devi Darshan Package offers private cab transportation for devotees traveling to Vani. The itinerary can be customized according to darshan plans, passenger requirements, sightseeing preferences, and return journey needs."
  },
  {
    "name": "Shirdi Saptashrungi One-Day Tour",
    "description": "Shirdi Saptashrungi One-Day Tour is suitable for devotees planning a compact pilgrimage between Shirdi and Saptashrungi. Private cabs can be arranged for temple darshan, travel breaks, and convenient return transportation."
  },
  {
    "name": "Shirdi Saptashrungi Pilgrimage Package",
    "description": "Shirdi Saptashrungi Pilgrimage Package provides private transportation for devotees combining important religious destinations in Maharashtra. The itinerary can include Saptashrungi darshan, Nashik visits, Shirdi travel, and customized temple stops."
  },
  {
    "name": "Shirdi to Saptashrungi Temple Tour",
    "description": "Shirdi to Saptashrungi Temple Tour provides convenient transportation for travelers planning a dedicated visit to Saptashrungi Mata Temple. Cars, SUVs, and larger group vehicles can be selected according to the number of passengers."
  },
  {
    "name": "Family Cab for Saptashrungi Darshan",
    "description": "Family Cab for Saptashrungi Darshan provides comfortable private travel for families visiting the temple from Shirdi. Suitable vehicle options can accommodate children, senior citizens, luggage, and different family group sizes."
  }
],
"tableData": [
  ["Shirdi to Saptashrungi Taxi Fare", "Shirdi to Saptashrungi Cab Package"],
  ["Shirdi to Saptashrungi Vani Cab Booking", "Shirdi to Vani Gad Cab Booking"],
  ["Shirdi to Vani Cab Booking", "Shirdi to Vani Saptashrungi Taxi Service"],
  ["Shirdi to Saptashrungi Darshan Cab Booking", "Shirdi to Saptashrungi Tour Package"],
  ["Shirdi to Vani Saptashrungi Mini Bus Booking", "Shirdi to Vani Saptashrungi Tempo Traveller on Rent"],
  ["Shirdi to Nashik Darshan Cab Service", "Shirdi to Saptashrungi Cab"],
  ["Shirdi to Saptashrungi Taxi", "Shirdi to Saptashrungi Cab Service"],
  ["Shirdi to Saptashrungi Taxi Service", "Shirdi to Saptashrungi Cab Booking"],
  ["Cab from Shirdi to Saptashrungi", "Taxi from Shirdi to Saptashrungi"],
  ["Shirdi to Saptashrungi Devi Cab", "Shirdi to Saptashrungi Mata Taxi"],
  ["Shirdi Saptashrungi Darshan Cab", "Shirdi to Saptashringi Cab"],
  ["Shirdi to Saptshrungi Taxi", "Sedan Cab Shirdi to Saptashrungi"],
  ["Swift Dzire Cab Shirdi to Saptashrungi", "Ertiga Cab Shirdi to Saptashrungi"],
  ["Innova Cab Shirdi to Saptashrungi", "Innova Crysta Shirdi to Saptashrungi"],
  ["Kia Carens Cab Shirdi to Saptashrungi", "Seven-Seater Cab Shirdi to Saptashrungi"],
  ["Tempo Traveller Shirdi to Saptashrungi", "Mini Bus Shirdi to Saptashrungi"],
  ["Family Cab Shirdi to Saptashrungi", "Group Taxi Shirdi to Vani"],
  ["Urbania on Rent Shirdi to Saptashrungi", "Shirdi to Saptashrungi Darshan Package"],
  ["Shirdi Saptashrungi Mata Darshan Cab", "Saptashrungi Devi Darshan Taxi from Shirdi"],
  ["Shirdi to Vani Devi Darshan Package", "Shirdi Saptashrungi One-Day Tour"],
  ["Shirdi Saptashrungi Pilgrimage Package", "Shirdi to Saptashrungi Temple Tour"],
  ["Family Cab for Saptashrungi Darshan", "Shirdi to Saptashrungi Darshan Package"]
],




        whychoose: [
            { 
                WhyChooseheading: "Devotional Shirdi to Saptashrungi Cab Journey", 
                WhyChoosedescription: "Sai Shirdi Cabs provides private cab transportation for devotees travelling from Shirdi to Saptashrungi. The service is suitable for families, senior citizens, pilgrims, and groups planning a temple visit to Saptashrungi Gad along with their Shirdi pilgrimage." 
            }, 
            { 
                WhyChooseheading: "Start Directly from Your Shirdi Pickup Point", 
                WhyChoosedescription: "Arrange pickup from your hotel, residence, railway station area, or another convenient location in Shirdi. Direct transportation allows your group to begin the journey towards Saptashrungi without arranging separate local transfers." 
            }, 
            { 
                WhyChooseheading: "Convenient for Saptashrungi Devi Darshan", 
                WhyChoosedescription: "Devotees visiting the revered Saptashrungi Devi Temple can plan their journey with a dedicated cab. Private transportation provides flexibility to organize departure and return timings around your Darshan schedule." 
            }, 
            { 
                WhyChooseheading: "Comfortable Option for Family Pilgrimages", 
                WhyChoosedescription: "Families travelling with children, parents, and senior citizens can remain together throughout the trip. A suitable vehicle can be selected according to the number of passengers, luggage, and comfort requirements." 
            }, 
            { 
                WhyChooseheading: "One-Way Cab to Saptashrungi", 
                WhyChoosedescription: "Passengers continuing their journey from the Saptashrungi area can choose a one-way cab from Shirdi. This option is convenient when onward transportation has already been planned separately." 
            }, 
            { 
                WhyChooseheading: "Round-Trip Cab for Temple Visit", 
                WhyChoosedescription: "Devotees who want to return to Shirdi after completing Saptashrungi Devi Darshan can arrange a round-trip cab. The return journey can be planned according to the temple visit and overall travel schedule." 
            }, 
            { 
                WhyChooseheading: "Useful for Religious Trips & Nearby Travel", 
                WhyChoosedescription: "The cab can also be useful for travellers combining their Saptashrungi visit with other religious or sightseeing destinations around Nashik. Additional stops can be discussed while planning the itinerary." 
            }, 
            { 
                WhyChooseheading: "Book Shirdi to Saptashrungi Cab with Sai Shirdi Cabs", 
                WhyChoosedescription: "Share your Shirdi pickup location, travel date, passenger count, luggage details, preferred vehicle, and one-way or return requirement with Sai Shirdi Cabs to arrange suitable transportation for your pilgrimage." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I book a cab from Shirdi to Saptashrungi?", 
            answer: "Yes, Sai Shirdi Cabs provides cab services from Shirdi to Saptashrungi for devotees, families, senior citizens, tourists, and pilgrimage groups." 
        }, 
        { 
            question: "Can I travel to Saptashrungi for Devi Darshan from Shirdi?", 
            answer: "Yes, devotees can arrange a private cab from Shirdi to Saptashrungi Gad for Saptashrungi Devi Darshan and other pilgrimage requirements." 
        }, 
        { 
            question: "Is one-way cab service available from Shirdi to Saptashrungi?", 
            answer: "Yes, one-way taxi service can be arranged for passengers who require direct transportation from Shirdi to Saptashrungi and have separate plans for their onward or return journey." 
        }, 
        { 
            question: "Can I book a round-trip taxi from Shirdi to Saptashrungi?", 
            answer: "Yes, round-trip cab arrangements are available for devotees who want to visit Saptashrungi Temple and return to Shirdi after completing their Darshan." 
        }, 
        { 
            question: "Is the Shirdi to Saptashrungi Cab suitable for senior citizens?", 
            answer: "Yes, private cab travel can be convenient for families travelling with senior citizens because the group can remain together in a dedicated vehicle throughout the journey." 
        }, 
        { 
            question: "Can families book a private cab to Saptashrungi?", 
            answer: "Yes, families can select a suitable vehicle according to passenger count, luggage requirements, and preferred comfort level for their pilgrimage journey." 
        }, 
        { 
            question: "Can I include other Nashik sightseeing places in the trip?", 
            answer: "Yes, additional religious or sightseeing stops can be discussed while arranging the cab, particularly when planning a customized or round-trip itinerary." 
        }, 
        { 
            question: "Can I carry luggage in the Shirdi to Saptashrungi taxi?", 
            answer: "Yes, passengers can carry personal luggage according to the capacity of the selected vehicle. Any additional or bulky baggage should be mentioned during booking." 
        }, 
        { 
            question: "Can I request an early morning cab from Shirdi?", 
            answer: "Yes, passengers can request an early morning departure according to their pilgrimage schedule. The required pickup time should be provided when making the booking." 
        }, 
        { 
            question: "How can I book Shirdi to Saptashrungi Cab with Sai Shirdi Cabs?", 
            answer: "Share your Shirdi pickup point, Saptashrungi destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Sai Shirdi Cabs for booking assistance." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Ramesh Gaikwad", 
            feedback: "We travelled from Shirdi to Saptashrungi with our family for Devi Darshan. The private cab was convenient for our group, especially as we were travelling with elderly family members and luggage.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Vaishali Patil", 
            feedback: "Our pilgrimage included Shirdi and Saptashrungi Temple. Having a dedicated cab made the journey easier to organize and allowed our family to travel together according to our planned schedule.", 
            rating: 5 
        } 
    ];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Saptashrungi Cab",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-saptashrungi-cab.webp",
  "description":
    "Book Shirdi to Saptashrungi Cab with Sai Shirdi Cabs for safe, comfortable, and reliable pilgrimage taxi services. We provide affordable one-way and round-trip cabs from Shirdi to Saptashrungi with convenient pickup and drop facilities for temple visits, family trips, and religious tours. Sedan, Ertiga, SUV, Innova, Innova Crysta, and Tempo Traveller options are available for individuals and groups seeking comfortable outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-saptashrungi-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Shirdi to Saptashrungi Cab | Taxi Fare & Booking | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to Saptashrungi Cab with Sai Shirdi Cabs for affordable one-way and round-trip taxi services. Get comfortable Sedan, Ertiga, SUV, Innova, Innova Crysta, and Tempo Traveller options for Saptashrungi temple visits, pilgrimage tours, family travel, and religious journeys."
  />

  <meta
    name="keywords"
    content="Shirdi to Saptashrungi Taxi Fare, Sai Shirdi Cabs, Shirdi to Saptashrungi Cab, Shirdi to Saptashrungi Taxi, Shirdi to Saptashrungi Cab Booking, Shirdi to Saptashrungi One Way Cab, Shirdi to Saptashrungi Round Trip Taxi, Shirdi to Saptashrungi Temple Taxi, Shirdi to Saptashrungi Car Rental, Saptashrungi Temple Cab from Shirdi, Shirdi Pilgrimage Taxi, Shirdi Religious Tour Cab, Shirdi to Saptashrungi Outstation Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditosaptashrungicab;